module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sign-in-button-group"
  }, [_c('div', {
    staticClass: "sign-in-button-cell post-sign-in"
  }, [_c('button', {
    staticClass: "post-sign-in__button button",
    class: _vm.signinButtonClasses,
    attrs: {
      "disabled": _vm.signinButtonDisabled
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSignin()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.signinSubmitButtonText) + "\n    ")]), _vm._v(" "), (_vm.enableSignout) ? _c('button', {
    staticClass: "post-sign-in__button button",
    class: _vm.signoutButtonClasses,
    attrs: {
      "disabled": _vm.signoutButtonDisabled
    },
    on: {
      "click": function($event) {
        _vm.onSubmitSignout()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.signoutSubmitButtonText) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.hasSignIn) ? _c('button', {
    staticClass: "post-sign-in__button button",
    class: _vm.cancelButtonClasses,
    on: {
      "click": function($event) {
        _vm.onCancelSignIn()
      }
    }
  }, [_vm._v("\n      撤销签到\n    ")]) : _vm._e()]), _vm._v(" "), _c('draw-signature-modal', {
    attrs: {
      "visible": _vm.showSignatureModal
    },
    on: {
      "confirm": _vm.handleSignatureConfirm,
      "cancel": _vm.handleSignatureCancel
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68954f80", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-68954f80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Activity/SignInButton.vue
// module id = 861
// module chunks = 0